import { useMutation } from "@apollo/client"
import { Classes, Icon } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomDialog from "components/Atoms/CustomDialog"
import CustomTag from "components/Atoms/CustomTag"
import MultiLineCell from "components/Templates/table/MultiLineCell"
import TimeCell from "components/Templates/table/TimeCell"
import { APPROVE_REQUEST } from "graphql/stock-take/stock-take.mutations.gql"
import React from "react"
import { ErrorToast, SuccessToast } from "utils/AppToaster"
import classNames from "utils/classNames"

const ApproveDialog = ({
  isOpen,
  item,
  dcDetails,
  onClose,
  refreshData,
  ...otherProps
}) => {
  const [approveRequest] = useMutation(APPROVE_REQUEST)

  return (
    <CustomDialog
      title={
        <div>
          <text>Details | Pending requests</text>
        </div>
      }
      isOpen={isOpen}
      width="50%"
      onClose={onClose}
      {...otherProps}
    >
      <div>
        <div className="flex  justify-between">
          <div className={Classes.TEXT_SMALL}>
            <div className={classNames(Classes.UI_TEXT, "mb-1")}>
              {dcDetails?.name}
            </div>
            <MultiLineCell
              title={dcDetails?.dcoName}
              subtitle={dcDetails?.dcoNumber}
            />
          </div>

          <div className={Classes.TEXT_SMALL}>
            <div className="mb-1">
              <MultiLineCell
                title={item?.requestedBy}
                subtitle={item?.requestedByNumber}
              />
            </div>
            <TimeCell timeStamp={item?.requestedAt} />
          </div>

          <div className={Classes.TEXT_SMALL}>
            <div className={Classes.UI_TEXT}>{item?.sellableItemName}</div>
            <div className="mt-1">
              Physical stock:{" "}
              <CustomTag
                intent={
                  item?.totalCount < item?.systemCount
                    ? "danger"
                    : item?.totalCount > item?.systemCount
                    ? "warning"
                    : "success"
                }
                minimal
                interactive
              >
                {item?.totalCount}
                <span className="vt-muted vt-font-sx"> Units</span>
              </CustomTag>
            </div>
            <div className="mt-1">
              {item?.totalCount === item?.systemCount ? (
                <div className="flex items-center">
                  <Icon icon="tick-circle" intent="success" />
                  <div className="ml-2">No mismatch</div>
                </div>
              ) : item?.totalCount < item?.systemCount ? (
                <div className="flex items-center">
                  <Icon icon="tick-circle" intent="danger" />
                  <div className="ml-2">
                    {item?.systemCount - item?.totalCount} items less
                  </div>
                </div>
              ) : item?.totalCount > item?.systemCount ? (
                <div className="flex items-center">
                  <Icon icon="warning-sign" intent="warning" />
                  <div className="ml-2">
                    {item?.totalCount - item?.systemCount} items more
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div
          className={classNames(
            "flex items-center justify-between mt-6",
            Classes.UI_TEXT
          )}
        >
          <div>
            <MultiLineCell title={"Batch number"} subtitle={item?.codeName} />
          </div>
          <div>
            <MultiLineCell title={"Fresh"} subtitle={item?.freshCount} />
          </div>
          <div>
            <MultiLineCell title={"Resale"} subtitle={item?.resaleCount} />
          </div>
          <div>
            <MultiLineCell title={"Total"} subtitle={item?.totalCount} />
          </div>
          <div>
            <MultiLineCell title={"Remark"} subtitle={item?.remark} />
          </div>
        </div>
        <hr />
        <div
          className={classNames(
            "flex items-center justify-between mt-6",
            Classes.UI_TEXT,
            "mx-auto"
          )}
        >
          {item?.sellableItemPhotoUrl && (
            <img
              className="mx-auto"
              width="400"
              height="400"
              src={item?.sellableItemPhotoUrl}
              alt="sellable-item"
            />
          )}
        </div>
        <hr />
        <div className="flex items-center justify-around mt-6">
          <CustomButton
            text="Disapprove"
            intent="danger"
            icon="cross"
            large={true}
            onClick={() => {
              approveRequest({
                variables: {
                  obj: {
                    id: item?.listId,
                    status: ["REJ"],
                  },
                },
              }).then(({ data, error }) => {
                if (error) {
                  ErrorToast(error.message)
                  return
                }
                refreshData(new Date().getTime())
                SuccessToast("Order disapproved successfully")
                onClose()
              })
            }}
          />
          <CustomButton
            text="Approve"
            intent="success"
            icon="tick"
            large={true}
            onClick={() => {
              approveRequest({
                variables: {
                  obj: {
                    id: item?.listId,
                    status:
                      item?.totalCount === item?.systemCount
                        ? ["APR"]
                        : ["AUD"],
                  },
                },
              }).then(({ data, error }) => {
                if (error) {
                  ErrorToast(error.message)
                  return
                }
                refreshData(new Date().getTime())
                SuccessToast("Order approved successfully")
                onClose()
              })
            }}
          />
        </div>
      </div>
    </CustomDialog>
  )
}

export default ApproveDialog
